import React from "react";
import Countdown from "../bond-wheel/Countdown";
import { PENDING_CASINO_BET_WARN_SECONDS } from "../../utils/casinoPendingExpiry";

const BondSpinPendingExpiryHint = ({ deadline, secondsLeft }) => {
  if (deadline == null || secondsLeft == null || secondsLeft <= 0) return null;

  const tone =
    secondsLeft > 0 && secondsLeft <= PENDING_CASINO_BET_WARN_SECONDS ? "lock" : "live";

  return (
    <div className="bplay-spin-expiry-meta" role="status" aria-live="polite">
      <Countdown deadline={deadline} size="hero" tone={tone} />
    </div>
  );
};

export default BondSpinPendingExpiryHint;
